export class RouteError extends Error {
  title?: string

  constructor(message: string, title?: string) {
    super(message)
    this.name = 'RouteError'
    this.title = title
  }
}
